export default __webpack_public_path__ + "static/media/profileIcon.95f12990.svg";